class SubCollectionsSwiper {
  constructor() {
    this.swipers = []; // store Swiper instances
    this.init();
  }

  init() {
    const swiperElements = document.querySelectorAll('.collection-grid.js-center');

    swiperElements.forEach(element => {
      if (element.swiper && window.innerWidth >= 768) {
        element.swiper.destroy(true, true);
        return;
      }

      // Only initialize Swiper if screen is less than 768px and not already initialized
      if (window.innerWidth < 768 && !element.swiper) {
        const swiper = new Swiper(element, {
          slidesPerView: "auto",
          spaceBetween: 10,
         scrollbar: {
            el: ".swiper-scrollbar",
            hide: true,
          },
          pagination: {
            el: element.querySelector('.swiper-pagination'),
            clickable: true
          },
          
        });

        this.swipers.push(swiper);
      }
    });
  }
}

// Initialize once on DOM load
document.addEventListener('DOMContentLoaded', () => {
  window.subCollectionsSwiper = new SubCollectionsSwiper();
});

// Re-initialize on resize with debounce
let resizeTimerr;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimerr);
  resizeTimerr = setTimeout(() => {
    window.subCollectionsSwiper.init(); // call init, not new instance
  }, 250);
});
